/* unplugin-vue-components disabled */import { render } from "./Code.vue?vue&type=template&id=85710d64"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__